
import React from 'react';
import Contact from '../components/Contact';
import './ContactPage.css';
import './ContactPage.css';

function ContactPage() {
  return <Contact />;
}

export default ContactPage;
